import { Location } from '@angular/common';
import { Inject } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { FormValueInterface, LazyFacadeInterface } from '@ellf/app-common';
import { RouterService } from '@ellf/app-routing';
import { BaseDbDto } from '@ellf/common-dto';
import { BaseFormContainer } from './base-form-container';

export abstract class LazyBaseFormContainer<
  FormT extends FormValueInterface,
  T extends BaseDbDto,
> extends BaseFormContainer<FormT, T> {
  constructor(
    protected router: RouterService,
    @Inject('FormFacade') protected facade: LazyFacadeInterface<T>,
    protected permissionsService: NgxPermissionsService,
    location: Location,
  ) {
    super(router, facade, permissionsService, location);
  }
}
